// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aYNP","questions":"styles_questions__3OR15","footer":"styles_footer__1gIlF"};